import { useSubmissionQuery } from '~/public/lib/PublicQueries';
import { useSetCurrency } from '~/lib/CurrencyHelpers';
import ThemedForm from '~/components/forms/ThemedForm';
import FormBackgroundContainer from '~/components/forms/FormBackgroundContainer';
import PageContainer from '~/public/components/PageContainer';
import Loading from '~/components/Loading';
import FormThankYou from '~/public/components/FormThankYou';
import ErrorMessage from '~/components/ErrorMessage';
import { useSetLocale } from '~/lib/useSetLocale.js';

const ThemedConfirmationContainer = ({ token, children }) => {
    const { data, isLoading } = useSubmissionQuery(token);

    useSetLocale(data?.context);

    return (
        <ThemedForm styles={data?.form?.settings?.styles}>
            <FormBackgroundContainer styles={data?.form?.settings?.styles}>
                <PageContainer>
                    {isLoading && <Loading className="text-center" />}
                    {data && !data.error && children(data)}
                    {!!data?.error && (
                        <ErrorMessage className="text-center">
                            <div>{data?.error}</div>
                            <div>Please check the link and try again.</div>
                        </ErrorMessage>
                    )}
                </PageContainer>
            </FormBackgroundContainer>
        </ThemedForm>
    );
};

export default ThemedConfirmationContainer;
